//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

export function rephrase(dto: Types.RephraseDto, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/ai/rephrase";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeRephraseDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigRephrase,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigRephrase?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRephrase(_response);
    });
}

function processRephrase(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
    
        result200 = resultData200;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

export function describeVariable(dto: Types.DescribeVariableDto, config?: AxiosRequestConfig | undefined): Promise<Types.PostChatMessageResult> {
    let url_ = getBaseUrl() + "/api/ai/describe";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeDescribeVariableDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigDescribeVariable,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigDescribeVariable?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDescribeVariable(_response);
    });
}

function processDescribeVariable(response: AxiosResponse): Promise<Types.PostChatMessageResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPostChatMessageResult(resultData200);
        return Promise.resolve<Types.PostChatMessageResult>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PostChatMessageResult>(null as any);
}

export function processChatMessage(dto: Types.ProcessChatMessageDto, config?: AxiosRequestConfig | undefined): Promise<Types.PostChatMessageResult> {
    let url_ = getBaseUrl() + "/api/ai/chat";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeProcessChatMessageDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigProcessChatMessage,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigProcessChatMessage?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processProcessChatMessage(_response);
    });
}

function processProcessChatMessage(response: AxiosResponse): Promise<Types.PostChatMessageResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPostChatMessageResult(resultData200);
        return Promise.resolve<Types.PostChatMessageResult>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PostChatMessageResult>(null as any);
}
let _requestConfigRephrase: Partial<AxiosRequestConfig> | null;
export function getRephraseRequestConfig() {
  return _requestConfigRephrase;
}
export function setRephraseRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRephrase = value;
}
export function patchRephraseRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRephrase = patch(_requestConfigRephrase ?? {});
}

let _requestConfigDescribeVariable: Partial<AxiosRequestConfig> | null;
export function getDescribeVariableRequestConfig() {
  return _requestConfigDescribeVariable;
}
export function setDescribeVariableRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDescribeVariable = value;
}
export function patchDescribeVariableRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDescribeVariable = patch(_requestConfigDescribeVariable ?? {});
}

let _requestConfigProcessChatMessage: Partial<AxiosRequestConfig> | null;
export function getProcessChatMessageRequestConfig() {
  return _requestConfigProcessChatMessage;
}
export function setProcessChatMessageRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigProcessChatMessage = value;
}
export function patchProcessChatMessageRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigProcessChatMessage = patch(_requestConfigProcessChatMessage ?? {});
}